module.exports = __webpack_public_path__ + "static/media/DSCF0141-w5uoiYgs.b2426472.JPG";